module.exports = __webpack_public_path__ + "img/logo.c87a7c9c.png";